import { render, staticRenderFns } from "./HeroNews.vue?vue&type=template&id=41bf76ca&scoped=true"
import script from "./HeroNews.vue?vue&type=script&lang=js"
export * from "./HeroNews.vue?vue&type=script&lang=js"
import style0 from "./HeroNews.vue?vue&type=style&index=0&id=41bf76ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bf76ca",
  null
  
)

export default component.exports